import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {FileUploadEvent, FileUploadModule} from "primeng/fileupload";
import {FormElementComponent} from "../../../shared/forms/form-element/form-element.component";
import {PaginatorModule} from "primeng/paginator";
import {TranslatePipe} from "@ngx-translate/core";
import {FormTypes} from "../../../shared/forms/models/constants";
import {FormGroup, ReactiveFormsModule} from "@angular/forms";
import {MessageService} from "primeng/api";
import {FileModel} from "../../model/file-model";
import { ChipModule } from 'primeng/chip';
import {ChipsModule} from "primeng/chips";

@Component({
    selector: 'app-comments-and-observers',
    standalone: true,
    imports: [
        FileUploadModule,
        FormElementComponent,
        PaginatorModule,
        TranslatePipe,
        ReactiveFormsModule,
        ChipModule,
        ChipsModule
    ],
    providers: [
        MessageService
    ],
    templateUrl: './comments-and-observers.component.html',
    styleUrl: './comments-and-observers.component.scss'
})
export class CommentsAndObserversComponent implements OnInit {

    @Input() formGroup!: FormGroup;
    @Output() outFormGroup = new EventEmitter();
    protected readonly FormTypes = FormTypes;

    @Input() files: File[] = [];
    @Output() outFiles = new EventEmitter<File[]>();
    uploadedBase64Files: FileModel[] = [];

    @Input() isCloseTriggered!: boolean;

    constructor(private messageService: MessageService) {
    }

    ngOnInit() {
        this.formGroup.valueChanges.subscribe(value => {
            console.log(value);
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['isCloseTriggered']) {
            this.callEmitEvents();
        }
    }

    // onUpload(event: FileUploadEvent) {
    //     for (let file of event.files) {
    //         this.uploadedFiles.push(file);
    //     }
    //
    //     this.messageService.add({severity: 'info', summary: 'File Uploaded', detail: ''});
    // }

    // onUpload(event: FileUploadEvent) {
    //     for (let file of event.files) {
    //         const reader = new FileReader();
    //         alert();
    //         reader.onload = () => {
    //             const base64 = (reader.result as string).split(',')[1]; // Strip metadata
    //             this.uploadedBase64Files.push({
    //                 name: file.name,
    //                 content: base64
    //             });
    //
    //             this.messageService.add({
    //                 severity: 'info',
    //                 summary: 'File processed',
    //                 detail: file.name
    //             });
    //         };
    //
    //         reader.readAsDataURL(file);
    //     }
    // }

    removeFile(event: any) {
        this.files = this.files.filter(file => file !== event.file);
    }


    originalSelectedFiles: File[] = [];
    protected observers: any;

    onFileSelect(event: any) {
        this.originalSelectedFiles = event.files; // 👈 Original Files lokal sichern
        this.files = event.currentFiles;

        for (let file of this.originalSelectedFiles) {
            const reader = new FileReader();
            reader.onload = () => {
                const base64 = (reader.result as string).split(',')[1];
                this.uploadedBase64Files.push({
                    name: file.name,
                    content: base64
                });
            };
            reader.readAsDataURL(file);
        }
    }

    callEmitEvents() {
        const result = {
            files: this.uploadedBase64Files,
            formGroup: this.formGroup
        }

        this.outFormGroup.emit(result);
        this.outFiles.emit(this.files)
    }

    ngOnDestroy(): void {
        this.callEmitEvents();
    }
}
